import React from 'react'

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, IconButton, Tooltip, Typography } from '@material-ui/core/'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  titleBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 64,
    borderRadius: 4,
    padding: theme.spacing(2),
    backgroundColor: '#0B79D0',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 0,
    [theme.breakpoints.up('sm')]: {
      flex: 1,
    },
  },
  title: {
    color: theme.palette.common.white,
    fontWeight: 400,
    fontSize: 20,
    marginRight: theme.spacing(1),
  },
  tooltip: {
    padding: 5,
  },
  subtitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  subtitle: {
    color: theme.palette.common.white,
    fontWeight: 400,
    fontSize: 14,
    marginRight: theme.spacing(1),
  },
  data: {
    fontSize: 20,
    fontWeight: 500,
    textAlign: 'right',
    color: theme.palette.common.white,
  },
  secondaryData: {
    textAlign: 'right',
    color: theme.palette.common.white,
  },
}))

const BannerHeader = ({ title, subtitle, tooltip, data, secondaryData }) => {
  const styles = useStyles()

  return (
    <Box
      mb={2}
      className={styles.titleBar}
    >
      <Box className={styles.titleSubtitleContainer}>
        <Box className={styles.titleContainer}>
          <Typography
            variant="h6"
            className={styles.title}
          >
            {title}
          </Typography>

          {tooltip && (
            <Tooltip
              title={tooltip}
              interactive
              aria-label={tooltip}
              className={styles.tooltip}
            >
              <IconButton>
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  color="white"
                  className="fa-xs"
                />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        {subtitle && (
          <Typography
            variant="body2"
            className={styles.subtitle}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      <Box>
        {data && (
          <Typography
            variant="body1"
            className={styles.data}
          >
            {data}
          </Typography>
        )}

        {secondaryData && (
          <Typography
            variant="body1"
            className={styles.secondaryData}
          >
            {secondaryData}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

BannerHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  tooltip: PropTypes.string,
  data: PropTypes.string,
  secondaryData: PropTypes.string,
}

export default BannerHeader
